// extracted by mini-css-extract-plugin
module.exports = {"online":"ScreenManagerTable_online__TFfRN","offline":"ScreenManagerTable_offline__12sid"};